export const enum MAP_TYPES {
    ROADMAP = 'roadmap',
    SATELLITE = 'satellite'
}
export const MAP_TYPE = MAP_TYPES.ROADMAP;
export const MAP_ZOOM = 5;
export const MAP_PROJECTION_WGS84 = 'EPSG:4326';
export const MAP_PROJECTION_OL = 'EPSG:3857';
export const MAPBOX_ROADMAP_URL = 'https://api.mapbox.com/styles/v1/netfarm/clf17lix0001q01mr2260m1pd?access_token=pk.eyJ1IjoibmV0ZmFybSIsImEiOiJja2Eyb2U5am0wN3o4M2xsOXplMDJxNXdlIn0.BSH7zdFf44g4HhZiagsZkg';
export const MAPBOX_SATELLITE_URL = 'https://api.mapbox.com/styles/v1/netfarm/clj5svchf003x01pi9ndj789y?access_token=pk.eyJ1IjoibmV0ZmFybSIsImEiOiJja2Eyb2U5am0wN3o4M2xsOXplMDJxNXdlIn0.BSH7zdFf44g4HhZiagsZkg';
export const DEVICESETS_LAYER_CLASS = 'devicesets';
export const DEVICE_LAYER_CLASS = 'device';
export const ELEMENTS_LAYER_CLASSES = [DEVICESETS_LAYER_CLASS];
export const SEVERITY_COLORS = { '0': '#00A927', '100': '#FFBB67', '200': '#D92100' };
export const SEVERITY_LABELS = { '0': 'Ok', '100': 'Allerta Gialla', '200': 'Allerta Rossa' };
export const WKTOPTIONS = {
    dataProjection: MAP_PROJECTION_WGS84,
    featureProjection: MAP_PROJECTION_OL
};